import { Manager } from './Manager';
import { IGameState } from '../State/Store/store';
import { ItemIDs } from '../Config/Items';
import Core from '../Core/Core';
import { helperEnabled, helperTimers } from '../Config/Helpers';
import { Timer } from '../Utils/Timer';
import { HudActions, HudEmitter } from './Hud/HudEmitter';
import { IStateLevel } from '../State/reducers/level';
import { IStateBoosters } from '../State/reducers/boosters';
import { BoosterUtils } from './Boosters/BoosterUtils';

export default class Helpers extends Manager {
    private helperTimer: Timer;
    private showedHelper: boolean;

    constructor() {
        super();

        this.addSelector(
            (state: IStateLevel, pre: IStateLevel) => {
                if (state.selected !== pre.selected) {
                    this.resetHelperTimer();
                }
            },
            (state: IGameState) => state.StateLevel
        );

        this.addSelector(
            (state: IStateBoosters, pre: IStateBoosters) => {
                this.handleBoosterInterrupt(state, pre);
            },
            (state: IGameState) => state.StateBoosters
        );
    }

    public reset() {
        this.showedHelper = false;
        this.resetHelperTimer();
    }

    public cleanUp() {
        super.cleanUp();
        this.destroyHelperTimer();
    }

    private resetHelperTimer() {
        const itemId = ItemIDs.HINT;
        const { levelIndex, timed } = Core.store.getState().StateLevel;
        const useHelpers = helperEnabled(levelIndex, itemId);
        if (this.showedHelper || !useHelpers) {
            return;
        }
        this.destroyHelperTimer();
        this.helperTimer = new Timer(
            1000 * (timed ? helperTimers.timed : helperTimers.normal),
            async () => {
                if (Core.store.getState().StateBoosters.activeBoosters.includes(itemId)) {
                    this.resetHelperTimer();
                    return;
                }
                HudEmitter.instance.emit(HudActions.SHOW_BOOSTER_PARACHUTE, itemId);
                this.showedHelper = true;
            }
        );
    }

    public destroyHelperTimer() {
        const { helperTimer } = this;
        if (helperTimer) {
            helperTimer.destroy();
            this.helperTimer = null;
        }
    }

    private handleBoosterInterrupt(state: IStateBoosters, previous: IStateBoosters) {
        const waiting = BoosterUtils.getAddedBoosters(state, previous, 'waitingBoosters');
        if (waiting.length > 0) {
            this.destroyHelperTimer();
        }

        const activated = BoosterUtils.getAddedBoosters(state, previous, 'activeBoosters');
        if (activated.length > 0) {
            this.resetHelperTimer();
        }
    }
}
